module.exports = __webpack_public_path__ + "media/images/google_ad_manager/728x90-3d6f27efc8a5fb7e0ef6d009ee683c52.png";